/* eslint-disable react-hooks/exhaustive-deps */
import '@/styles/supervise.scss';
import React, { useState, useEffect, useRef } from 'react';
import { ListView, PullToRefresh, DatePicker, Toast } from 'antd-mobile';
import moment from 'moment';
import { getUser } from '@/utils';
import { useHistory } from 'react-router';
import sysConfig from '@/sysConfig';
import {
  conferencePage,
  abnormalpage,
  selectconferencepage,
  myconferencepage,
} from '@/services/saas/supervise';

const { preRouteUrl } = sysConfig;

const CloseIcon = (props) => (
  <svg
    className={props.className}
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="close-circle"
    width="3.6vw"
    height="3.6vw"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
  </svg>
);

function ListWrap(props) {
  return <ul className="supervise-list">{props.children}</ul>;
}

function SearchWrapper(props) {
  const [searchValue, setSearchValue] = useState('');
  const [date, setDate] = useState(new Date());
  const { onChange = () => {}, changeDate = () => {} } = props;
  const handleChange = (e) => {
    e.persist();
    setSearchValue(e.target.value);
  };

  return (
    <div className="supervise-search">
      <div className="supervise-search-input">
        <em className="supervise-search-input-icon" />
        <input
          type="text"
          value={searchValue}
          placeholder="课程、教室名称或老师姓名"
          onChange={handleChange}
          onBlur={() => {
            onChange(searchValue);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              onChange(searchValue);
            }
          }}
        />
        {searchValue && (
          <span
            onClick={() => {
              setSearchValue('');
              onChange('');
            }}
          >
            <CloseIcon className={'supervise-search-input-close'} />
          </span>
        )}
      </div>
      <div className="supervise-search-screen">
        <DatePicker
          mode="date"
          title="日期选择"
          extra="Optional"
          value={date}
          onChange={(value) => {
            setDate(value);
            changeDate(moment(value).format('YYYY-MM-DD'));
          }}
        >
          <em></em>
        </DatePicker>
      </div>
    </div>
  );
}

function RTS(props) {
  const { type } = props;
  const pageSize = 5;
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [name, setName] = useState('');
  const [time, setTime] = useState(moment().format('YYYY-MM-DD'));
  const history = useHistory();
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSource] = useState(dataS);
  const [dataList, setDataList] = useState([]);
  const listRef = useRef();
  const { userId, deptId: deptDataAuth } = getUser();

  const getData = async (page) => {
    setLoading(true);
    let list = [],
      url = '',
      resp,
      _live = preRouteUrl + '/supervise/supervisePlay/live/',
      _back = preRouteUrl + '/supervise/supervisePlay/back/',
      _detail = preRouteUrl + '/supervise/supervisePlay/detail/';
    const params = {
      current: page,
      size: 6,
      // sceneCode: 8,
      type: 2,
      teacherId: userId || '',
      deptDataAuth: deptDataAuth || '',
      keyword: name || '',
      time: time || '',
      conferenceStatus: '',
      deptId: '',
    };
    switch (type) {
      case 'realTime':
        params.conferenceStatus = '01';
        url = _live;
        resp = await conferencePage(params);
        break;
      case 'afterClass':
        params.conferenceStatus = '2';
        url = _back;
        resp = await conferencePage(params);
        break;
      case 'anomalyTracing':
        params.deptId = deptDataAuth;
        url = _detail;
        resp = await abnormalpage(params);
        break;
      case 'superviseQuery':
        url = _detail;
        resp = await selectconferencepage(params);
        break;
      case 'mySupervisor':
        resp = await myconferencepage(params);
        break;
      default:
        break;
    }

    if (resp && resp.success) {
      const data = resp.data.pages.records || resp.data.records;
      list = data.map((item, index) => ({
        id: item.id,
        time: item.scheduledStartTime || '',
        name: item.name || '',
        teacher: item.realName || '',
        faculty:
          item.conferenceAttributeDetailList.length > 0 ? item.conferenceAttributeDetailList : '',
        classroom: item.roomName || '',
        score: parseFloat(item.sumScore) ? parseFloat(item.sumScore).toFixed(1) : 0,
        ddNum: parseInt(item.ddNum) ? item.ddNum : 0,
        status: item.conferenceStatus,
        url:
          type === 'mySupervisor'
            ? item.conferenceStatus === '1'
              ? _live + item.id
              : _back + item.id
            : url + item.id,
      }));
    }
    setLoading(false);
    setRefreshing(false);
    setDataList(page === 1 ? list : [...list]);
    setDataSource(dataSource.cloneWithRows(page === 1 ? list : [...dataList, ...list]));
    if (resp && resp.data && resp.data.pages.records) {
      setHasMore(resp.data.pages.current < resp.data.pages.pages);
    } else if (resp && resp.data && resp.data.records) {
      setHasMore(resp.data.current < resp.data.pages);
    } else {
      setHasMore(false);
    }
    setIndex(page);
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };
  const row = (rowData, sectionID, rowID) => {
    const { time, name, teacher, faculty, classroom, score, url, ddNum, status } = rowData;
    return (
      <li
        className="supervise-list-item"
        key={'supervise-list-item_' + rowID}
        onClick={() => {
          if (type === 'realTime' && status === '0') {
            Toast.info('该督导课程尚未开始！');
          } else {
            history.push(`${url}`);
          }
        }}
      >
        <div className="item-header">
          <p className="item-datetime">
            <em></em>
            <span>{time}</span>
          </p>
        </div>
        <div className="item-content">
          <div className="item-content-left">
            <p className="item-lesson">
              <label>课程：</label>
              <span>{name}</span>
            </p>
            <p className="item-teacher">
              <label>老师：</label>
              <span>{teacher}</span>
            </p>
            <p className="item-faculty">
              <label>学科：</label>
              <span>
                {faculty &&
                  faculty.map((item, index) => {
                    if (index < faculty.length - 1) {
                      return item.attributeValueName + ' ';
                    } else {
                      return item.attributeValueName;
                    }
                  })}
              </span>
            </p>
            <p className="item-classroom">
              <label>教室：</label>
              <span>{classroom}</span>
            </p>
          </div>
          <div className="item-content-right">
            <p className="item-score">
              <em>{'realTime,afterClass'.indexOf(type) > -1 ? ddNum : score}</em>
              <span>{'realTime,afterClass'.indexOf(type) > -1 ? '督导次数' : '督导评分'}</span>
            </p>
          </div>
        </div>
      </li>
    );
  };

  useEffect(() => {
    getData(1);
  }, [name, time]);

  return (
    <div className="supervise-realTime">
      <SearchWrapper onChange={setName} changeDate={setTime} />
      <ListView
        ref={listRef}
        dataSource={dataSource}
        renderHeader={() => null}
        renderFooter={() => (
          <div style={{ padding: '5vw', textAlign: 'center' }}>
            {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="supervise-content"
        pageSize={pageSize}
        scrollRenderAheadDistance={100}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={refreshing}
            onRefresh={() => {
              setRefreshing();
              getData(1);
            }}
          />
        }
      />
    </div>
  );
}

export default RTS;
